import { NBSP } from 'shared/constants/symbols';

export const BANNER_UTP = [
  {
    id: 1,
    title: 'Войдите в личный кабинет или зарегистрируйтесь',
  },
  {
    id: 2,
    title: `Оставьте ваши контакты в${NBSP}форме*`,
    notice: '*форма будет доступна только новым пользователям Циан Посуточно',
  },
  {
    id: 3,
    title: `Бонусы отобразятся в${NBSP}личном кабинете в${NBSP}течение нескольких минут`,
    notice: 'Их можно потратить на услуги продвижения, чтобы привлечь внимание гостей и получить больше броней',
  },
];
